import { combineReducers, createReducer, on } from '@ngrx/store';
import { removeModelPortfolioToRefresh, setModelPortfolioToRefresh } from './refresh-holdings-modal.action';
export const REFRESH_HOLDINGS_MODAL_STATE_SLICE_KEY = 'refreshHoldingsModal';
export const modelPortfolioToRefresh = createReducer(null, on(setModelPortfolioToRefresh, (state, action) => {
    if (action.modelPortfolio)
        return { ...action.modelPortfolio };
    return null;
}), on(removeModelPortfolioToRefresh, () => {
    return null;
}));
export const refreshHoldingsModal = combineReducers({
    modelPortfolioToRefresh,
});
